import {
  multiselectFilter,
  MultiselectCriteria,
  MultiselectFilterChangeFunction,
  MultiselectColumnDefinition,
} from "../generic/MultiselectColumnDefinition";

export const TICKER_CRITERIA_KEY = "tickers";

type Ticker = string;

export function getSortedTickers<TItemKey extends string>(
  key: TItemKey,
  rows: Array<{
    [key in TItemKey]: Ticker;
  }>,
) {
  const values = Array.from(new Set(rows.map((row) => row[key])).values());
  values.sort();

  return values;
}

export const tickersFilter = <TItemKey extends string>(key: TItemKey) => multiselectFilter(TICKER_CRITERIA_KEY, key);

export const TickerColumnDefinition = <TItemKey extends string>(
  itemKey: TItemKey,
  criteria: MultiselectCriteria<typeof TICKER_CRITERIA_KEY, Ticker>,
  onFilterChange: MultiselectFilterChangeFunction<typeof TICKER_CRITERIA_KEY, Ticker>,
  tickers: Ticker[],
) =>
  MultiselectColumnDefinition(
    "Ticker",
    itemKey,
    TICKER_CRITERIA_KEY,
    criteria,
    onFilterChange,
    tickers,
    (a) => a,
    (a) => a,
    120,
  );
